import { NgClass } from "@angular/common";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { SvgIconComponent } from "@app/components/utils/svg-icon/svg-icon.component";
import { NavigationState, NvdbNavigationService } from "@app/service/nvdb-navigation.service";
import { TrvMapExtensionService } from "@app/service/trv-map-extension.service";
import { SWEDEN_VIEW } from "@app/shared/constants";
import { SvgIcon } from "@app/shared/utils/svg-helper";
import {
    svgPrinter,
    svgGoogleMaps,
    svgRuler,
    svgPin,
    svgTimeBack,
    svgInfo,
    svgHand,
    svgMagnifyingGlass,
    svgMagnifyingPlusFilled,
    svgEraser,
    svgSweden,
    svgRightArrow,
    svgArrowLeft,
    svgMapLocation,
} from "@app/shared/utils/svg-helper-data";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { faArrowDown, faArrowUp, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { MapTools, MapToolsType, TrvNgMapService } from "@trafikverket/trv-ng-map";
import { trvCollapseStateAnimation, trvCollapseVoidAnimation, TrvPopoverDirective, TrvPopoverRef } from "@trv-hub/trv-ng-common";
import { environment } from "src/environments/environment";
import { take } from "rxjs";

@Component({
    selector: "app-mobile-map-buttons",
    imports: [SvgIconComponent, FaIconComponent, NgClass],
    templateUrl: "./mobile-map-buttons.component.html",
    styleUrl: "./mobile-map-buttons.component.scss",
    animations: [trvCollapseVoidAnimation]
})
export class MobileMapButtonsComponent {
    protected printerIcon: SvgIcon = svgPrinter;
    protected googleMapsIcon: SvgIcon = svgGoogleMaps;
    protected rulerIcon: SvgIcon = svgRuler;
    protected pinIcon: SvgIcon = svgPin;
    protected timeBackIcon: SvgIcon = svgTimeBack;
    protected infoIcon: SvgIcon = svgInfo;
    protected handIcon: SvgIcon = svgHand;
    protected zoomIcon: SvgIcon = svgMagnifyingGlass;
    protected zoomIconPlus: SvgIcon = svgMagnifyingPlusFilled;
    protected eraserIcon: SvgIcon = svgEraser;
    protected swedenIcon: SvgIcon = svgSweden;
    protected svgRightArrow = svgRightArrow;
    protected svgArrowLeft = svgArrowLeft;
    protected svgMapLocation = svgMapLocation;
    protected faArrowDown = faChevronDown;
    protected faArrowUp = faChevronUp;


    public menuOpen = false;

    public mobileMenuItems: MobileMenuItem[] = [];

    @ViewChild("datePopoverRef") datePopoverRef!: TrvPopoverDirective;

    public currentDatePopoverRef?: TrvPopoverDirective;

    constructor(
        public trvMapService: TrvNgMapService,
        public nvdbNavigationService: NvdbNavigationService,
        public trvExtensionService: TrvMapExtensionService,
        private cdref: ChangeDetectorRef
    ) {
        this.trvExtensionService.initEmitter.subscribe(() => {
            this.mobileMenuItems = [
                { icon: this.handIcon, func: this.changeTool.bind(this), mapTool: MapTools.Pointer, condition: true },
                { icon: this.zoomIconPlus, func: this.changeTool.bind(this), mapTool: MapTools.Zoom, condition: true },
                { icon: this.swedenIcon, func: this.zoomToSweden.bind(this), mapTool: MapTools.NONE, condition: true },
                { icon: this.rulerIcon, func: this.changeTool.bind(this), mapTool: MapTools.Ruler, condition: true },
                { icon: this.pinIcon, func: this.changeTool.bind(this), mapTool: MapTools.PinPosition, condition: true },
                //{ icon: this.eraserIcon, func: this.eraser.bind(this), mapTool: MapTools.None, condition: true  },
                { icon: this.printerIcon, func: this.changeTool.bind(this), mapTool: MapTools.ExportRectangle, condition: true },
                {
                    icon: this.googleMapsIcon,
                    func: this.changeTool.bind(this),
                    mapTool: MapTools.StreetView,
                    condition:
                        environment.application == "NvdbDataleverans" || (environment.local == "true" && environment.application == "NvdbPåKarta"),
                },
                {
                    icon: this.timeBackIcon,
                    func: null,
                    mapTool: -4,
                    condition:
                        environment.application == "NvdbDataleverans" || (environment.local == "true" && environment.application == "NvdbPåKarta"),
                    openModal: true,
                },
                { icon: this.infoIcon, func: this.changeTool.bind(this), mapTool: MapTools.InfoClick, condition: true },
            ];
        });

        this.nvdbNavigationService.currentMobileMenuState.valueChanges.subscribe(state => {
            this.menuOpen = false;
        });
    }

    public clickIcon(item: MobileMenuItem) {
        item.func(item.mapTool);
    }

    public getCurrentMobileMenuItem(): MobileMenuItem {
        let found = this.mobileMenuItems.find(x => x.mapTool === this.trvMapService.trvMap?.activeMapTool.value);
        if (found) return found;
        return this.mobileMenuItems[0];
    }

    private zoomToSweden(mapTool: MapToolsType) {
        this.trvMapService.trvMap?.setMapStateWithCoord(SWEDEN_VIEW.centerCoordinate, SWEDEN_VIEW.zoom, undefined, undefined, 1000, true);
        this.menuOpen = false;
    }

    public showPopover(event: Event) {
        if(this.datePopoverRef != this.currentDatePopoverRef && this.currentDatePopoverRef != undefined) {
            this.currentDatePopoverRef.hide();
            this.currentDatePopoverRef = undefined;
        } 
        if (this.datePopoverRef) this.currentDatePopoverRef = this.datePopoverRef;

        if (this.currentDatePopoverRef) {
            if (this.currentDatePopoverRef.active) this.currentDatePopoverRef.hide();
            else this.currentDatePopoverRef.show();
        }

        this.cdref.detectChanges();
    }


    public onAfterCloseWithType(event: any): void {
        this.cdref.detectChanges();
    }

    public eraser(mapTool: MapToolsType) {
        this.trvMapService.trvMap?.trvInteractions.eraserTool();
        this.menuOpen = false;
    }

    private changeTool(mapTool: MapToolsType) {
        if (!this.trvMapService.trvMap) return;
        if (mapTool == MapTools.InfoClick) {
            this.changeNavigationState(NavigationState.InfoClick);
            return;
        }
        if (mapTool == MapTools.ExportRectangle) {
            this.changeNavigationState(NavigationState.PrintMap);
            return;
        }
        if (this.trvMapService.trvMap.activeMapTool?.value == mapTool) mapTool = MapTools.Pointer;

        this.trvMapService.trvMap.changeActiveMapTool(mapTool);

        this.menuOpen = false;
    }

    changeNavigationState(newState: NavigationState) {
        if (!this.trvMapService.trvMap) return;

        if (newState == this.nvdbNavigationService.navigationState) {
            const checkInfo = newState == NavigationState.InfoClick && this.trvMapService.trvMap!.activeMapTool.value == MapTools.InfoClick;
            const checkExport = newState == NavigationState.PrintMap && this.trvMapService.trvMap!.activeMapTool.value == MapTools.ExportRectangle;

            if (checkInfo || checkExport) {
                this.trvMapService.trvMap.changeActiveMapTool(MapTools.Pointer);

                if (checkExport) {
                    this.nvdbNavigationService.navigationState = NavigationState.MainMenu;
                    this.nvdbNavigationService.navigationStateChanged.emit();
                }

                return;
            }
        }
        this.menuOpen = false;

        this.nvdbNavigationService.navigationState = newState;
        this.nvdbNavigationService.navigationStateChanged.emit();
    }
}

interface MobileMenuItem {
    icon: SvgIcon;
    func: any;
    mapTool: MapToolsType;
    condition: boolean;
    openModal?: boolean;
}
